type SaveShortcutEvent = {
  altKey: boolean;
  code: string;
  ctrlKey: boolean;
  key: string;
  metaKey: boolean;
  shiftKey: boolean;
};

function isSaveShortcut(event: SaveShortcutEvent) {
  const hasSaveModifier = event.ctrlKey || event.metaKey;
  const isSaveKey =
    event.key.toLowerCase() === 's'
    || event.code === 'KeyS'
    || event.key === 'Enter';

  return (
    hasSaveModifier
    && isSaveKey
    && !event.altKey
    && !event.shiftKey
  );
}

export default isSaveShortcut;
